export default __webpack_public_path__ + "static/univers-light-239afe72a3c567606e6acad2eea38a12.woff";